var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-layout',{attrs:{"column":"","fill-height":""}},[_c('breadcrumbs',{attrs:{"guia":"Processos Judiciais","titulo":"Processos Judiciais","descricao":"Gerencie e acompanhe os processos de seus clientes."}}),_c('v-layout',{staticClass:"main"},[_c('processos')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }